import styled from 'styled-components'

export const Item = styled.a`
    background-color: #fff;
    padding: 0.8rem;
    margin-bottom: 0.5rem;
    color: #333;

    &:hover {
        text-decoration: none;
        color: ${props => props.theme.admin.colors.brand};
    }
`

export const InfoPanel = styled.div`
    background-color: #fff;
    padding: 0.8rem;
    margin-bottom: 0.8rem;

    p {
        margin-bottom: 0.5rem;

        &:last-child {
            margin-bottom: 0;
        }
    }

    hr {
        margin-top: 0.8rem;
        margin-bottom: 0.8rem;
    }
`
